import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormAlertModule } from '@core/form-alert/form-alert.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomPdfViewerModule } from '../../custom-pdf-viewer/custom-pdf-viewer.module';
import { DocumentModalComponent } from './document-modal.component';

@NgModule({
    declarations: [DocumentModalComponent],
    imports: [
        NgbModule,
        CommonModule,
        HttpClientModule,
        NgxSpinnerModule,
        CustomPdfViewerModule,
        FormAlertModule,
    ],
    exports: [DocumentModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DocumentModalModule {}
